// Leaf module: which deployment this bundle is and which resources it talks
// to. Imports only the pure rules from @peekapak/common, so modules evaluated
// early in a cycle (staticConfiguration, ApplicationState) can depend on it.
//
// The build scripts export REACT_DEPLOY_STAGE and REACT_RESOURCE_ENVIRONMENT;
// REACT_USE_DEV_API and REACT_TEST_PROD_API keep their old meaning for builds
// that only set those. See packages/common/lib/deployStageResolution.ts.
import {
  apiBasePath as apiBasePathForStage,
  resolveBuildTarget,
  sentryEnvironmentForStage,
  type ResourceEnvironment,
} from '@peekapak/common/lib/deployStageResolution';

function buildTarget() {
  return resolveBuildTarget(import.meta.env);
}

/** dev, pre, stg or prod: names the API base paths and the host. */
export function getDeployStage(): string {
  return buildTarget().deployStage;
}

/** dev or prod: names the Cognito pools, configuration block and third-party keys. */
export function getResourceEnvironment(): ResourceEnvironment {
  return buildTarget().resourceEnvironment;
}

export function isDevelopmentBackend(): boolean {
  return getResourceEnvironment() === 'dev';
}

/** `commonservices` on prod, `commonservicesdev`, `commonservicespre`, ... */
export function apiBasePath(service: string): string {
  return apiBasePathForStage(service, getDeployStage());
}

export function getSentryEnvironment(): string {
  return sentryEnvironmentForStage(getDeployStage());
}
